/**
 * This Middleware is used to filter calls for CEAP Users. 
 * Given any Engagement, If user is CEAP user then restrict to only GET calls
 * Action is filtered only if the user is CEAP user
 * API calls with method other than GET will not continue to next middleware
 */

import _ from 'lodash';

const ceapUserMiddleware = (config) => (store) => (next) => (action) => {
	if (!action.isOnline) {
		return next(action);
    }
    
    const ceap_user= store.getState().userPreferences.isCEAPUser;

    if(_.isBoolean(ceap_user) && !ceap_user){
        return next(action);
    }
    if(action.meta && action.meta.api && action.meta.api.method!=='GET'){
        return next({type:"WARNING_MESSAGE",message:"CEAP USER: CANNOT MODIFY"})
    }
    return next(action);
	
	
};

export default ceapUserMiddleware;
